import { createSelector } from 'reselect'

import { filterUser } from '../../../records/User'

const defaultSort = u => u.get('first_name') + ' ' + u.get('last_name')

const getFilter = (state, { filter } = {}) => filter
const getSort = (state, { sortBy = defaultSort } = {}) => sortBy
const getUser = (state, { userId }) => userId
const getUsers = state => state.user.get('users')

export const makeSelectUser = () => createSelector(
  [getUsers, getUser],
  (users, userId) => users.find(u => u.id === userId),
)

export const makeSelectUsers = () => createSelector(
  [getUsers, getFilter, getSort],
  (users, filter, sortBy) => users
    .filter(u => filterUser(filter, u))
    .sortBy(sortBy),
)



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/user/selectors.js